import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './index.css';
if (typeof window !== "undefined") {
  // Ignore ResizeObserver errors
  const ignoreResizeObserverError = (e) => {
    if (
      e.message === "ResizeObserver loop completed with undelivered notifications." ||
      e.message === "ResizeObserver loop limit exceeded"
    ) {
      e.stopImmediatePropagation?.();
      return true;
    }
    return false;
  };

  window.addEventListener("error", (e) => {
    if (ignoreResizeObserverError(e)) {
      // Optionnel : tu peux aussi supprimer l'affichage dans la console
      console.warn("Erreur ResizeObserver ignorée");
    }
  });

  window.addEventListener("unhandledrejection", (e) => {
    // Gère les erreurs de promesse non interceptées
    console.warn("Rejet non intercepté :", e.reason);
  });

  window.showModalAbonnement = () => {
    const event = new CustomEvent("showModalAbonnement");
    window.dispatchEvent(event);
  };
  
} 
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
